<script setup lang="ts">
import { ref, onMounted } from 'vue'

const isVisible = ref(false)

onMounted(() => {
  const consent = localStorage.getItem('voxbet-cookie-consent')
  if (!consent) {
    isVisible.value = true
  }
})

const acceptAll = () => {
  localStorage.setItem('voxbet-cookie-consent', 'true')
  isVisible.value = false
}
</script>

<template>
  <Transition name="fade">
    <div v-if="isVisible" class="cookie-banner">
      <div class="container">
        <div class="banner-inner">
          <div class="banner-content">
            <h3>Cookie Policy</h3>
            <p>We use cookies to enhance your experience and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.</p>
          </div>
          <div class="banner-actions">
            <button @click="acceptAll" class="btn btn-primary">Accept All</button>
            <RouterLink to="/cookie-policy" class="policy-link">Learn More</RouterLink>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: rgba(10, 10, 10, 0.98);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 25px 0;
  color: #fff;
  z-index: 10000;
  box-shadow: 0 -10px 50px rgba(0,0,0,0.5);
}

.banner-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
}

.banner-content {
  flex: 1;
}

.banner-content h3 {
  font-size: 20px;
  margin-bottom: 5px;
  color: var(--voxbet-neon-green);
}

.banner-content p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.7);
}

.banner-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
}

.policy-link {
  text-decoration: underline;
  color: var(--voxbet-neon-green);
  font-size: 14px;
  font-weight: 500;
}

.btn {
  padding: 12px 30px;
  font-size: 14px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1), transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

@media (max-width: 992px) {
  .banner-inner {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  
  .banner-actions {
    width: 100%;
    justify-content: center;
  }
}
</style>
